import styles from './NoData.css'

class NoData extends React.Component {
  render () {
    return (<div className={styles.wrapper}>
      <div className={styles.text}>No Data</div>
    </div>

    )
  }
}

export default NoData



// WEBPACK FOOTER //
// ./app/pages/Dashboard/NoData/NoData.js